export default __webpack_public_path__ + "static/media/team-3.51dea6c9.jpg";